import { SupportedConnectors } from '../config/constants';
import {
    bitkeep,
    fortmatic,
    fox,
    injected,
    ledger,
    nabox,
    okx,
    portis,
    torus,
    trezor,
    uauth,
    walletConnect,
    walletlink,
} from './connectors';

const walletConnections: Record<SupportedConnectors, any> = {
    [SupportedConnectors.METAMASK]: injected,
    [SupportedConnectors.PORTIS]: portis,
    [SupportedConnectors.WALLET_CONNECT]: walletConnect,
    [SupportedConnectors.LEDGER]: ledger,
    [SupportedConnectors.COINBASE]: walletlink,
    [SupportedConnectors.TORUS]: torus,
    [SupportedConnectors.TREZOR]: trezor,
    [SupportedConnectors.FORTMATIC]: fortmatic,
    [SupportedConnectors.UAUTH]: uauth,
    [SupportedConnectors.BITKEEP]: bitkeep,
    [SupportedConnectors.NABOX]: nabox,
    [SupportedConnectors.FOX]: fox,
    [SupportedConnectors.OKX]: okx,
};

export const ClosableWallet = [
    SupportedConnectors.WALLET_CONNECT,
    SupportedConnectors.COINBASE,
    SupportedConnectors.PORTIS,
    SupportedConnectors.TORUS,
    SupportedConnectors.FORTMATIC,
    SupportedConnectors.UAUTH,
];

export default walletConnections;
